import { render, staticRenderFns } from "./DashboardOperacao.vue?vue&type=template&id=3caa3ce6&lang=pug"
import script from "./DashboardOperacao.vue?vue&type=script&lang=js"
export * from "./DashboardOperacao.vue?vue&type=script&lang=js"
import style0 from "./DashboardOperacao.vue?vue&type=style&index=0&id=3caa3ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports